import type { UserConnection, UserConnectionActionType } from '@alltrails/types/belay';
import { updateUserConnection } from '@alltrails/redux/slices/userConnections';
import { useAppDispatch } from '../utils/redux';

const useConnectAction = (userConnection: UserConnection | null, actionKey?: UserConnectionActionType): (() => void) | null => {
  const dispatch = useAppDispatch();

  if (!userConnection || !actionKey) {
    return null;
  }

  return () => {
    if (!(actionKey in userConnection.actions)) return;

    const href = userConnection.actions[actionKey]?.href;
    const method = userConnection.actions[actionKey]?.method;
    if (!href || !method) return;

    dispatch(updateUserConnection({ href, method, userConnection, actionKey }));
  };
};

export default useConnectAction;
